module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/icon-align-to-center-horizontal.bc4992a03119c55fdd4beebe38715c03.svg";